module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/lightTank-prem-tiny.f51e39d7.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/lightTank-prem-tiny.png
// module id = 2721
// module chunks = 11